import React from "react";
import cn from "classnames";
import styles from "./ColumnSortArrow.module.scss";

import { SortArrowDownIcon, SortArrowUpIcon } from "../../../../assets/icons";

const ColumnSortArrow = ({ isSortByDesc, sortArrowClassName }) => {
  return (
    <span className={cn(styles.arrow, sortArrowClassName)}>
      {isSortByDesc && <SortArrowDownIcon />}
      {!isSortByDesc && <SortArrowUpIcon />}
    </span>
  );
};

export default ColumnSortArrow;
